import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/images/hmf_logo.png';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <header className="header">
      <div className="container">
        <div className="logo">
          <Link to="/" onClick={closeMenu}>
            <img src={logo} alt="Help Mind Formation" />
          </Link>
        </div>

        <div className={`menu-icon ${isMenuOpen ? 'change' : ''}`} onClick={toggleMenu}>
          <div className="bar1"></div>
          <div className="bar2"></div>
          <div className="bar3"></div>
        </div>

        <nav className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
          <ul className="nav-links">
            <li><Link to="/" onClick={closeMenu}>ACCUEIL</Link></li>
            <li><Link to="/a-propos" onClick={closeMenu}>À PROPOS</Link></li>
            <li><Link to="/module-standard" onClick={closeMenu}>MODULE STANDARD</Link></li>
            <li><Link to="/module-jeune" onClick={closeMenu}>MODULE JEUNE</Link></li>
            <li><Link to="/sensibilisation" onClick={closeMenu}>SENSIBILISATION</Link></li>
            <li><Link to="/contact" onClick={closeMenu}>CONTACTEZ-MOI</Link></li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;
